import { render, staticRenderFns } from "./BlankBlock.vue?vue&type=template&id=797fc3bc&scoped=true&"
import script from "./BlankBlock.vue?vue&type=script&lang=js&"
export * from "./BlankBlock.vue?vue&type=script&lang=js&"
import style0 from "./BlankBlock.vue?vue&type=style&index=0&id=797fc3bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797fc3bc",
  null
  
)

export default component.exports